import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { concat, get, includes, map, size } from "lodash";

import { fetchGet } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";

import ProfileSearchInput from "../../Common/ProfileSearchInput";
import ProfileMatchExpress from "../../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpress";
import ProfileMatchExpressUnknown from "../../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpressUnknown";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const AddOccurrenceVisitorsForm = (props) => {
  const { classes, formValues, handleChange, hostAssociations } = props;
  const [otherVisitors, setOtherVisitors] = React.useState([]);
  const [unknownVisitors, setUnknownVisitors] = React.useState(0);

  React.useEffect(() => {
    const checkMissingProfiles = async () => {
      let missingProfiles = [];
      for (let i = 0; i < size(get(formValues, ["visitors"])); i++) {
        let v = get(formValues, ["visitors", i]);
        if (
          hostAssociations !== undefined &&
          !includes(
            map(hostAssociations, (h) => get(h, ["p1_profile", "id"])),
            v
          ) &&
          !includes(
            map(otherVisitors, (h) => h.id),
            v
          )
        ) {
          missingProfiles.push(await fetchGet(`profiles/${v}`));
        }
      }
      if (size(missingProfiles) > 0) {
        setOtherVisitors(
          update(otherVisitors, {
            $push: missingProfiles,
          })
        );
      }
    };
    checkMissingProfiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(formValues, ["visitors"]), hostAssociations]);

  React.useEffect(() => {
    if (size(get(formValues, ["unknownVisitors"])) > unknownVisitors) {
      setUnknownVisitors(size(get(formValues, ["unknownVisitors"])));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(formValues, ["unknownVisitors"])]);

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid item container className={classes.containerTitle}>
        <Grid item style={{ marginRight: "7px" }}>
          <img src={images.pedestrianIcon} alt="pedestrian" />
        </Grid>
        <Grid item>{I18n.get("scheduler_visitors")}</Grid>
        <Grid item xs />
        <Grid item style={{ textTransform: "none" }}>
          {(size(hostAssociations) > 0 || size(otherVisitors) > 0) && (
            <span
              className={classes.link}
              onClick={() =>
                handleChange(
                  "visitors",
                  size(get(formValues, ["visitors"])) ===
                    size(hostAssociations) + size(otherVisitors)
                    ? "selectNone"
                    : "selectAll",
                  size(get(formValues, ["visitors"])) ===
                    size(hostAssociations) + size(otherVisitors)
                    ? []
                    : concat(
                        map(hostAssociations, (p) =>
                          get(p, ["p1_profile", "id"])
                        ),
                        map(otherVisitors, (p) => p.id)
                      )
                )
              }
            >
              {I18n.get(
                size(get(formValues, ["visitors"])) ===
                  size(hostAssociations) + size(otherVisitors)
                  ? "profiles_deselectAll"
                  : "profiles_selectAll"
              )}
            </span>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <ProfileSearchInput
          profileType={1}
          flow="newAccount"
          id={"visitorProfile"}
          selectProfile={(profile) => {
            if (profile) {
              setOtherVisitors(update(otherVisitors, { $push: [profile] }));
              handleChange("visitors", null, get(profile, ["id"]));
            }
          }}
          selectedProfile={""}
          sizes={{
            inputDropdown: 350,
            profile: 420,
          }}
          express
          noMinHeight
          noLabel
          style={{ paddingTop: "22px", margin: "-6px 0px" }}
          disableNewProfile
        />
      </Grid>
      <Grid item className="flexCenter">
        <img
          src={images.plusIconColored}
          alt="plus"
          style={{ cursor: "pointer", marginRight: "6px" }}
          onClick={() => {
            setUnknownVisitors(unknownVisitors + 1);
            handleChange("unknownVisitors", null, unknownVisitors);
          }}
        />
        <span
          style={{color:"black"}}
        >
          {I18n.get("scheduler_unknownVisitor")}
        </span>
      </Grid>
      <Grid item>
        {map(new Array(unknownVisitors), (i, index) => (
          <ProfileMatchExpressUnknown
            key={index}
            type={1}
            style={{
              backgroundColor: colors.white,
              padding: 0,
              margin: "10px 0px",
            }}
            topRightNode={
              <Checkbox
                color="primary"
                checked={includes(get(formValues, ["unknownVisitors"]), index)}
                onChange={(e) => handleChange("unknownVisitors", null, index)}
                classes={{ root: classes.checkboxRoot }}
                size="small"
              />
            }
          />
        ))}
        {map(otherVisitors, (p) => (
          <ProfileMatchExpress
            key={p.id}
            profile={p}
            style={{
              backgroundColor: colors.white,
              padding: 0,
              margin: "10px 0px",
            }}
            topRightNode={
              <Checkbox
                color="primary"
                checked={includes(
                  get(formValues, ["visitors"]),
                  get(p, ["id"])
                )}
                onChange={(e) => handleChange("visitors", null, get(p, ["id"]))}
                classes={{ root: classes.checkboxRoot }}
                size="small"
              />
            }
          />
        ))}
        {map(hostAssociations, (ass) => (
          <ProfileMatchExpress
            key={ass.id}
            profile={get(ass, ["p1_profile"])}
            associations={get(ass, ["associations"])}
            style={{
              backgroundColor: colors.white,
              padding: 0,
              margin: "10px 0px",
            }}
            topRightNode={
              <Checkbox
                color="primary"
                checked={includes(
                  get(formValues, ["visitors"]),
                  get(ass, ["p1_profile", "id"])
                )}
                onChange={(e) =>
                  handleChange("visitors", null, get(ass, ["p1_profile", "id"]))
                }
                classes={{ root: classes.checkboxRoot }}
                size="small"
              />
            }
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default AddOccurrenceVisitorsForm;
